<div class="divParentSearch">
  <div class="search-content">
    <div class="searchbar">
      <button class="search_icon" (click)="searchToContent()">
        <i class="fas fa-search"></i>
      </button>
      <input
        class="search_input"
        [(ngModel)]="search"
        type="text"
        placeholder="Buscar casos"
      />

      <!-- (keyup)="searchToContent()" Esto estaba en el input -->
      <mat-icon (click)="searchTouch = !searchTouch" class="tune"
        >tune</mat-icon
      >
    </div>

    <filter-text-ras
      #filterTextRasComponent
      *ngIf="users && units"
      [units]="units"
      [users]="users"
      [open]="searchTouch"
    ></filter-text-ras>
  </div>
</div>

<div class="header">
  <div class="unit-title">
    <h3>
      <span> Buscador de texto</span>
    </h3>
  </div>
  <div *ngIf="optionSelect" class="selecType">
    <mat-select
      (ngModelChange)="changeType($event)"
      class="input-select margin-center"
      [(ngModel)]="optionSelect"
    >
      <mat-option *ngFor="let option of optionTextSearch" [value]="option">{{
        option
      }}</mat-option>
    </mat-select>
  </div>
</div>
